// Suivi de trafic minimal (2026-10-06) : une ligne par page vue, sans cookie
// ni identifiant (voir backend/sql/phase28_page_views.sql pour le choix).
// Meme structure que ScrollToTop, un composant = une seule responsabilite.
// 2026-10-24 : un onglet VISIBLE donne aussi signe de vie toutes les minutes (/api/analytics/ping) pour « Qui est en ligne » dans
// l'Admin ; ce signe de vie n'ajoute aucune page vue.
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../../services/supabaseClient';
import { lireCodeAdmin } from '../../services/adminApi';

const SIGNE_DE_VIE_MS = 60 * 1000;

// Si une session existe, on la joint : le serveur ne compte alors pas les administrateurs ni les testeurs (voir routes/analytics.js).
async function envoyer(adresse, corps) {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  } catch (_error) { /* visiteur sans session */ }
  // Le code d'acces de l'Admin (s'il a ete saisi dans cet onglet) : un administrateur entre par le code est reconnu lui aussi.
  const code = lireCodeAdmin();
  if (code && headers.Authorization) headers['x-admin-code'] = code;
  // keepalive : le dernier signe de vie part même si l'onglet est en train de se fermer.
  await fetch(adresse, { method: 'POST', headers, body: JSON.stringify(corps), keepalive: true });
}

const PageViewTracker = () => {
  const { pathname } = useLocation();
  // Le referrer n'a de sens qu'a la toute premiere page vue d'une session de
  // navigation (d'ou vient le visiteur) : les navigations internes
  // suivantes auraient pour "referrer" la page precedente DU MEME site, une
  // information deja portee par la succession des `path` eux-memes.
  const premierePage = useRef(true);
  const cheminCourant = useRef(pathname);
  cheminCourant.current = pathname;

  useEffect(() => {
    const referrer = premierePage.current ? document.referrer || null : null;
    premierePage.current = false;

    // Jamais bloquant, jamais d'erreur remontee a l'utilisateur : une visite
    // non comptee n'est jamais un probleme pour qui visite le site.
    envoyer('/api/analytics/pageview', { path: pathname, referrer }).catch(() => {});
  }, [pathname]);

  // 2026-11-03 : quitter l'onglet (le masquer ou le fermer) envoie un dernier signe de vie, { leaving: true } — c'est ce qui donne
  // le temps passé sur la dernière page dans Admin > Trafic > Détail. Il ne compte pas comme « en ligne ».
  useEffect(() => {
    const signeDeVie = () => {
      if (document.visibilityState !== 'visible') return;
      envoyer('/api/analytics/ping', { path: cheminCourant.current }).catch(() => {});
    };
    const changement = () => {
      if (document.visibilityState === 'visible') signeDeVie();
      else envoyer('/api/analytics/ping', { path: cheminCourant.current, leaving: true }).catch(() => {});
    };
    const minuteur = setInterval(signeDeVie, SIGNE_DE_VIE_MS);
    document.addEventListener('visibilitychange', changement);
    return () => { clearInterval(minuteur); document.removeEventListener('visibilitychange', changement); };
  }, []);

  return null;
};

export default PageViewTracker;
